module.exports = __webpack_public_path__ + "static/img/strona_001.96d4b421.jpg";